<p-tabs #tabMenu [scrollable]="scrollableTabs()" [value]="value" class="flex w-full flex-row">
  <p-tablist #containerRef class="w-full">
    @for (tab of tabs; track tab[key]) {
      <p-tab #tab [value]="tab[key]" (click)="handleActiveResultsTabChanged(tab)">
        <ng-container [ngTemplateOutlet]="tabTpl" [ngTemplateOutletContext]="{ item: tab }"></ng-container>
      </p-tab>
    }
  </p-tablist>
  <div
    *ngIf="completeTabsMoreList().length"
    class="tabs-button-wrapper flex items-center border-b-2 border-gray-300 px-1 pl-2 lg:hidden">
    <p-tieredMenu #menu [popup]="true" [model]="completeTabsMoreList()" [style]="{ width: '210px' }" appendTo="body">
      <ng-template #item let-item>
        <div *ngIf="item['useTpl']" class="cursor-pointer p-2" [ngClass]="{ 'p-menuitem-active': value === item[key] }">
          <ng-container [ngTemplateOutlet]="tabTpl" [ngTemplateOutletContext]="{ item }"></ng-container>
        </div>
        <div *ngIf="!item['useTpl']" class="cursor-pointer p-2">
          <span>{{ item.label }}</span>
        </div>
      </ng-template>
    </p-tieredMenu>
    <button
      type="button"
      class="p-button-text p-button-icon-only p-button-round"
      pButton
      icon="fa-solid fa-ellipsis-vertical"
      (click)="menu.toggle($event)"
      [title]="'common.settings' | translate"></button>
  </div>
</p-tabs>
